import * as React from 'react';
import Checkbox from '../checkbox';
import List from '../list';
import { useListItemStyles } from './use_styles';
import { jsx as ___EmotionJSX } from "@emotion/core";
var propsAreEqual = (prevProps, nextProps) => {
  var {
    checked: prevChecked,
    index: prevIndex,
    option: prevOption,
    selected: prevSelected
  } = prevProps;
  var {
    checked: nextChecked,
    index: nextIndex,
    option: nextOption,
    selected: nextSelected
  } = nextProps;
  return prevChecked === nextChecked && prevIndex === nextIndex && prevOption.id === nextOption.id && prevOption.label === nextOption.label && prevOption.required === nextOption.required && prevSelected === nextSelected;
};
var ListItem = /*#__PURE__*/React.memo(_ref => {
  var {
    theme,
    checked,
    handleCheckbox,
    handleClick,
    handleKeyDown,
    option,
    selected,
    index
  } = _ref;
  var onChange = React.useCallback(() => {
    handleCheckbox(option);
  }, [handleCheckbox, option]);
  var onClick = React.useCallback(() => {
    handleClick(option);
  }, [handleClick, option]);
  var onKeyDown = React.useCallback(e => {
    handleKeyDown(e, option);
  }, [handleKeyDown, option]);
  var style = useListItemStyles({
    theme,
    firstItem: index === 0,
    selected
  });
  return ___EmotionJSX("div", {
    "aria-selected": selected,
    css: style,
    onClick: onClick,
    onKeyDown: onKeyDown,
    role: "option",
    tabIndex: 0
  }, ___EmotionJSX(Checkbox, {
    checked: checked,
    disabled: option.required,
    label: option.label,
    onChange: onChange
  }));
}, propsAreEqual);
var ColumnOptionsList = _ref2 => {
  var {
    checkedColumns,
    handleCheckbox,
    handleClick,
    handleKeyDown,
    options,
    selectedColumn,
    theme
  } = _ref2;
  return ___EmotionJSX(List, {
    id: "column-options",
    role: "listbox"
  }, options.map((option, index) => ___EmotionJSX(ListItem, {
    checked: checkedColumns.includes(option.id) || option.required,
    handleCheckbox: handleCheckbox,
    handleClick: handleClick,
    handleKeyDown: handleKeyDown,
    index: index,
    key: option.id,
    option: option,
    selected: selectedColumn === option.id,
    theme: theme
  })));
};
ColumnOptionsList.displayName = 'ColumnOptionsList';
export default ColumnOptionsList;